import axios from 'axios';
import * as CookieService from '../Cookie/CookieService';

export function login( username, password ) {
    const requestBody = {
        "username" : username,
        "password" : password
    }
    return axios.post('/api/v1/auth', requestBody);
}

export function userProfile() {
    return axios.get('/api/v1/user/profile', CookieService.setHeaders());
}


export function isUserDuplicated( username) {
    return axios.get('/api/v1/user/duplicate?username=' + username, CookieService.setHeaders());
}

export function register( userVO ) {
    return axios.post('/api/v1/user', userVO);
}

export function searchByName( name ){
    const uriEncoded = encodeURI('/api/v1/user/profile/' + name);
    return axios.get(uriEncoded, CookieService.setHeaders());
}

export function searchByNameInStudent( name ) {
	const uriEncoded = encodeURI('/api/v1/user/profileinidentity?name=' + name+'&identity=I_STUDENT');
    return axios.get(uriEncoded, CookieService.setHeaders());
}

export function isFindID( name, academyName, phoneNum, identity, birth ){
    const uriEncoded = encodeURI('/api/v1/user/find?isFindId=true&name=' + name + '&academyName=' + academyName + '&phoneNum=' + phoneNum + '&identity=' + identity + '&birth=' + birth);
    
    return axios.get(uriEncoded, CookieService.setHeaders());
}

export function isFindPW( name, academyName, phoneNum, identity, birth ){
    const uriEncoded = encodeURI('/api/v1/user/find?isFindId=false&name=' + name + '&academyName=' + academyName + '&phoneNum=' + phoneNum + '&identity=' + identity + '&birth=' + birth);
    
    return axios.get(uriEncoded, CookieService.setHeaders());
}

export function findAllUsers(){
    return axios.get("/api/v1/users", CookieService.setHeaders());
}

export function findAllStudents() {
    return axios.get("/api/v1/user/student", CookieService.setHeaders());
}

export function updateStudent( userVO ) {
	return axios.put('/api/v1/user', userVO, CookieService.setHeaders());
}

export function deleteStudent(id) {
	const requestParams = {
			params: { "id": id },
			headers: CookieService.setHeader()
		    };
    return axios.delete('/api/v1/user', requestParams);
}




// WEBPACK FOOTER //
// ./src/services/User/UserService.js